/**
 * Main JavaScript file for the theme
 * Note: All libraries are loaded via Gulp concatenation from node_modules
 */

// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
	// Mobile menu toggle
	const menuToggle = document.querySelector('.menu-toggle');
	const mainNavigation = document.querySelector('.main-navigation');

	if (menuToggle) {
		menuToggle.addEventListener('click', () => {
			mainNavigation.classList.toggle('toggled');

			if (mainNavigation.classList.contains('toggled')) {
				menuToggle.setAttribute('aria-expanded', 'true');
			} else {
				menuToggle.setAttribute('aria-expanded', 'false');
			}
		});
	}

	// Sticky navigation animation - scroll direction based
	const stickyNav = document.querySelector('#vrb-navigation');
	if (stickyNav) {
		const STICK_MARGIN = 5;
		const SCROLL_UP_THRESHOLD = 48;

		let stickThreshold = stickyNav.offsetTop + STICK_MARGIN;
		let isStuck = false;
		let ticking = false;
		let lastScrollPos = window.pageYOffset;
		let scrollUpDistance = 0;

		function refreshStickThreshold() {
			stickThreshold = stickyNav.offsetTop + STICK_MARGIN;
		}

		function checkSticky() {
			const scrollPos = window.pageYOffset;

			if (scrollPos <= stickThreshold) {
				if (isStuck) {
					stickyNav.classList.remove('is-stuck');
					isStuck = false;
				}
				scrollUpDistance = 0;
				lastScrollPos = scrollPos;
				ticking = false;
				return;
			}

			const scrollDelta = scrollPos - lastScrollPos;

			if (scrollDelta > 0) {
				scrollUpDistance = 0;

				if (!isStuck && scrollPos > stickThreshold) {
					stickyNav.classList.add('is-stuck');
					isStuck = true;
				}
			} else if (scrollDelta < 0) {
				scrollUpDistance += Math.abs(scrollDelta);

				if (isStuck && scrollUpDistance >= SCROLL_UP_THRESHOLD) {
					stickyNav.classList.remove('is-stuck');
					isStuck = false;
				}
			}

			lastScrollPos = scrollPos;
			ticking = false;
		}

		let resizeTimer;
		window.addEventListener(
			'resize',
			() => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(() => {
					refreshStickThreshold();
				}, 150);
			},
			{ passive: true }
		);

		window.addEventListener('load', refreshStickThreshold, { passive: true });

		window.addEventListener(
			'scroll',
			() => {
				if (!ticking) {
					window.requestAnimationFrame(checkSticky);
					ticking = true;
				}
			},
			{ passive: true }
		);
	}

	// Initialize Swiper sliders
	initializeSwipers();

	// Initialize Fancybox
	initializeFancybox();

	// Smooth scroll for anchor links
	document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((anchor) => {
		anchor.addEventListener('click', function (e) {
			const target = document.querySelector(this.getAttribute('href'));

			if (target) {
				e.preventDefault();

				window.scrollTo({
					top: target.offsetTop - 100,
					behavior: 'smooth',
				});
			}
		});
	});

	// Add responsive table wrapper
	document.querySelectorAll('table').forEach((table) => {
		if (!table.closest('.table-responsive')) {
			const wrapper = document.createElement('div');
			wrapper.className = 'table-responsive';
			table.parentNode.insertBefore(wrapper, table);
			wrapper.appendChild(table);
		}
	});

	// Add external link icon and target="_blank"
	document.querySelectorAll('a').forEach((link) => {
		const url = link.href;

		if (url && url.indexOf(window.location.hostname) === -1 && url.startsWith('http')) {
			link.setAttribute('target', '_blank');
			link.setAttribute('rel', 'noopener noreferrer');

			// Only add icon if it doesn't contain an image
			if (!link.querySelector('img')) {
				link.classList.add('external-link');
			}
		}
	});
});

/**
 * Initialize Fancybox
 */
function initializeFancybox() {
	// Check if Fancybox is available (it should be loaded via Gulp)
	if (typeof window.Fancybox === 'undefined') {
		console.warn('Fancybox is not loaded');
		return;
	}

	// Bind Fancybox to all images with data-fancybox attribute
	window.Fancybox.bind('[data-fancybox]', {
		// Global options
		Toolbar: {
			display: {
				left: ['infobar'],
				middle: ['zoomIn', 'zoomOut', 'toggle1to1', 'rotateCCW', 'rotateCW', 'flipX', 'flipY'],
				right: ['slideshow', 'thumbs', 'close'],
			},
		},
		Thumbs: {
			autoStart: false,
		},
	});

	// Bind Fancybox to WordPress galleries
	window.Fancybox.bind('.gallery a', {
		groupAll: true, // Group all gallery images together
	});

	// Bind Fancybox to WordPress attachment pages
	window.Fancybox.bind('.wp-block-image a', {
		groupAll: true,
	});

	// Custom Fancybox for videos
	window.Fancybox.bind('[data-fancybox-video]', {
		// Video-specific options
	});
}

/**
 * Initialize all Swiper sliders on the page
 */
function initializeSwipers() {
	// Check if Swiper is available (it should be loaded via Gulp)
	if (typeof window.Swiper === 'undefined') {
		console.warn('Swiper is not loaded');
		return;
	}
	// Barber Slider
				const barberSwiper = document.querySelector(".barber-swiper");
				if (barberSwiper) {
					new window.Swiper('.barber-swiper', {
						loop: true,
						autoplay: {
							delay: 0,
						},
						speed: 3000,
						effect: 'coverflow',
						grabCursor: true,
						centeredSlides: true,
						slidesPerView: 7,
						coverflowEffect: {
							rotate: 32,
							stretch: 0,
							depth: -120,
							modifier: 1,
							slideShadows: true,
						},

					});
				}
	// Lineup Slider
				const lineupSwiper = document.querySelector(".lineup-Swiper");
				if (lineupSwiper) {
					new window.Swiper('.lineup-Swiper', {
						loop: true,
						autoplay: {
							delay: 4500,
						},
						slidesPerView: 7,
						spaceBetween: 10,
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
						},
						breakpoints: {
							'@0.00': {
								slidesPerView: 4,
								spaceBetween: 5,
							},
							'@0.75': {
								slidesPerView: 5,
								spaceBetween: 6,
							},
							'@1.00': {
								slidesPerView: 6,
								spaceBetween: 8,
							},
							'@1.50': {
								slidesPerView: 7,
								spaceBetween: 10,
							},
						},
					});
				}

	// Credibility Slider
				const credibilitySwiper = document.querySelector(".credibility-swiper");
				if (credibilitySwiper) {
					new window.Swiper('.credibility-swiper', {
						loop: true,
						speed: 8000,
						freeMode: true,
						cssEase: 'linear',
						autoplay: {
							delay: 10,
							disableOnInteraction: false,
						},
						grabCursor: true,
						// centeredSlides: true,
						slidesPerView: '5',
						breakpoints: {
							"@0.00": {
								slidesPerView: 3.5,
								spaceBetween: 10,
							},
							"@0.75": {
								slidesPerView:4.5,
								spaceBetween: 20,
							},
							"@1.00": {
								slidesPerView: 5,
								spaceBetween: 40,
							},
							"@1.50": {
								slidesPerView: 5.5,
								spaceBetween: 50,
							},
						}
					});
				}
	// Service Slider - Handle multiple instances with dynamic delays
				const serviceSwipers = document.querySelectorAll(".service-swiper");
				if (serviceSwipers.length > 0) {
					serviceSwipers.forEach((swiperEl) => {
						// Get delay from data attribute or default to 5000
						// const delay = //parseInt(swiperEl.getAttribute('data-autoplay-delay')) || 5000;

						new window.Swiper(swiperEl, {
							loop: true,
							// autoplay: {
							// 	delay: delay,
							// 	disableOnInteraction: false,
							// },
							grabCursor: true,
							slidesPerView: '5',
							breakpoints: {
									"@0.00": {
										slidesPerView: 3.5,
										spaceBetween: 0,
									},
									"@0.75": {
										slidesPerView: 5,
										spaceBetween: 0,
									},
									"@1.00": {
										slidesPerView: 5,
										spaceBetween: 0,
									},
									"@1.50": {
										slidesPerView: 5,
										spaceBetween: 0,
									},
							}
						});
					});
				}

				// Basic Hero Slider
				const heroSlider = document.querySelector('.hero-slider');
				if (heroSlider) {
					new window.Swiper('.hero-slider', {
						loop: true,
						// autoplay: {
						// 	delay: 5000,
						// 	disableOnInteraction: false,
						// },
						effect: 'fade',
						fadeEffect: {
							crossFade: true,
						},
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
						},
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
						},
					});
				}

				// Post Gallery Slider
				const postGallery = document.querySelector('.post-gallery-slider');
				if (postGallery) {
					new window.Swiper('.post-gallery-slider', {
						loop: true,
						spaceBetween: 10,
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
							dynamicBullets: true,
						},
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
						},
						keyboard: {
							enabled: true,
						},
						// Responsive breakpoints
						breakpoints: {
							640: {
								slidesPerView: 1,
							},
							768: {
								slidesPerView: 2,
							},
							1024: {
								slidesPerView: 3,
							},
						},
					});
				}

				// Testimonials Slider
				const testimonialsSlider = document.querySelector('.testimonials-slider');
				if (testimonialsSlider) {
					new window.Swiper('.testimonials-slider', {
						loop: true,
						autoplay: {
							delay: 4000,
						},
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
						},
						breakpoints: {
							640: {
								slidesPerView: 1,
								spaceBetween: 20,
							},
							768: {
								slidesPerView: 1,
								spaceBetween: 30,
							},
							1024: {
								slidesPerView: 1,
								spaceBetween: 40,
							},
						},
					});
				}

				// Related Posts Slider
				const relatedPostsSlider = document.querySelector('.related-posts-slider');
				if (relatedPostsSlider) {
					new window.Swiper('.related-posts-slider', {
						loop: false,
						spaceBetween: 20,
						slidesPerView: 1,
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
						},
						breakpoints: {
							576: {
								slidesPerView: 2,
							},
							992: {
								slidesPerView: 3,
							},
						},
					});
				}

				// Product/Portfolio Slider with Thumbs
				const mainSlider = document.querySelector('.main-slider');
				const thumbsSlider = document.querySelector('.thumbs-slider');

				if (mainSlider && thumbsSlider) {
					// Initialize thumbs slider first
					const swiperThumbs = new window.Swiper('.thumbs-slider', {
						spaceBetween: 10,
						slidesPerView: 4,
						freeMode: true,
						watchSlidesProgress: true,
						breakpoints: {
							640: {
								slidesPerView: 6,
							},
							768: {
								slidesPerView: 8,
							},
						},
					});

					// Initialize main slider with thumbs
					new window.Swiper('.main-slider', {
						loop: true,
						spaceBetween: 10,
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
						},
						thumbs: {
							swiper: swiperThumbs,
						},
					});
				}

				// Cards/Content Slider
				const cardsSlider = document.querySelector('.cards-slider');
				if (cardsSlider) {
					new window.Swiper('.cards-slider', {
						loop: true,
						spaceBetween: 30,
						centeredSlides: true,
						autoplay: {
							delay: 3000,
							disableOnInteraction: false,
						},
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
						},
						breakpoints: {
							640: {
								slidesPerView: 1,
							},
							768: {
								slidesPerView: 2,
							},
							1024: {
								slidesPerView: 3,
							},
						},
					});
				}

				// Full Screen Slider
				const fullscreenSlider = document.querySelector('.fullscreen-slider');
				if (fullscreenSlider) {
					new window.Swiper('.fullscreen-slider', {
						direction: 'vertical',
						loop: true,
						speed: 1000,
						autoplay: {
							delay: 4000,
						},
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
						},
						mousewheel: true,
						keyboard: {
							enabled: true,
						},
					});
				}

				// Service Style Slider
				const serviceStyleSwiperEl = document.querySelector(".myServiceStyleSwiper");
				if (serviceStyleSwiperEl) {
					// Get service labels dynamically from slides
					const serviceLabels = [];
					const slides = serviceStyleSwiperEl.querySelectorAll('.swiper-slide[data-style-name]');
					slides.forEach(function(slide) {
						serviceLabels.push(slide.getAttribute('data-style-name'));
					});

					const serviceStyleSwiper = new window.Swiper('.myServiceStyleSwiper', {
						loop: true,
						speed: 1000,
						effect: 'coverflow',
						grabCursor: true,
						centeredSlides: true,
						slideToClickedSlide: true,
						slidesPerView: 3,
						coverflowEffect: {
							rotate: 27,
							stretch: 0,
							depth: -100,
							modifier: 1,
							slideShadows: true,
						},
						breakpoints: {
							640: {
								slidesPerView: 3,
								spaceBetween: 5,
							},
							768: {
								slidesPerView: 3.5,
								spaceBetween: 10,
							},
							1280: {
								slidesPerView: 5,
								spaceBetween: 15,
							},
						},
						pagination: {
							el: '.myServiceStyleSwiper .swiper-pagination',
							clickable: true,
							type: 'bullets',
							renderBullet: function (index, className) {
								const labelIndex = index % serviceLabels.length;
								return (
									'<span class="' + className + '">' + (serviceLabels[labelIndex] || 'Style ' + (index + 1)) + '</span>'
								);
							},
						},
					});

					// ========================================
					// STYLE GALLERY SWITCHING LOGIC
					// ========================================

					// Function to switch gallery based on style ID
					function switchStyleGallery(styleId, styleName) {
						// Hide all style galleries
						var allGalleries = document.querySelectorAll('.style-gallery');
						// #region agent log
						console.log('[DEBUG H4] switchStyleGallery called:', { styleId: styleId, styleName: styleName, galleriesFound: allGalleries.length });
						// #endregion
						allGalleries.forEach(function(gallery) {
							gallery.style.display = 'none';
						});

						// Show the selected style's gallery
						var targetGallery = document.querySelector('.style-gallery[data-style-id="' + styleId + '"]');
						// #region agent log
						console.log('[DEBUG H4] Target gallery lookup:', { targetFound: !!targetGallery, selector: '.style-gallery[data-style-id="' + styleId + '"]' });
						// #endregion
						if (targetGallery) {
							targetGallery.style.display = 'block';
						}

						// Update the gallery title
						var titleSpan = document.getElementById('gallery-style-name');
						if (titleSpan && styleName) {
							// Remove " Cuts" from the end if present for cleaner title
							var cleanName = styleName.replace(/ Cuts$/, '').replace(/ Cut$/, '');
							titleSpan.textContent = cleanName;
						}

						// ========================================
						// BARBER SECTION SWITCHING (synced with style)
						// ========================================

						// Hide all style barber sections
						var allBarberSections = document.querySelectorAll('.style-barbers');
						allBarberSections.forEach(function(section) {
							section.style.display = 'none';
						});

						// Show the selected style's barbers
						var targetBarbers = document.querySelector('.style-barbers[data-style-id="' + styleId + '"]');
						if (targetBarbers) {
							targetBarbers.style.display = 'block';

							// Re-initialize swiper for this section if needed
							var swiperEl = targetBarbers.querySelector('.myServiceBarberSwiper');
							if (swiperEl && !swiperEl.swiper) {
								new window.Swiper(swiperEl, {
									slidesPerView: 5,
									spaceBetween: 10,
									additionalSlides: 1,
								});
							}
						}

						// Update the barber section title
						var barberTitleSpan = document.getElementById('barber-style-name');
						if (barberTitleSpan && styleName) {
							var cleanName = styleName.replace(/ Cuts$/, '').replace(/ Cut$/, '');
							barberTitleSpan.textContent = cleanName;
						}
					}

					// Function to get style info from current slide
					function updateGalleryFromStyleSlide() {
						var activeSlide = serviceStyleSwiper.slides[serviceStyleSwiper.activeIndex];
						// #region agent log
						console.log('[DEBUG H3] updateGalleryFromStyleSlide called:', { activeIndex: serviceStyleSwiper.activeIndex, realIndex: serviceStyleSwiper.realIndex, hasActiveSlide: !!activeSlide });
						// #endregion
						if (activeSlide) {
							var styleId = activeSlide.getAttribute('data-style-id');
							var styleName = activeSlide.getAttribute('data-style-name');
							// #region agent log
							console.log('[DEBUG H3] Slide data attributes:', { styleId: styleId, styleName: styleName, dataSwiperSlideIndex: activeSlide.getAttribute('data-swiper-slide-index') });
							// #endregion
							if (styleId) {
								switchStyleGallery(styleId, styleName);
							}
						}
					}

					// Update gallery when style swiper changes
					serviceStyleSwiper.on('slideChange', function() {
						// #region agent log
						console.log('[DEBUG H2] slideChange event fired:', { realIndex: serviceStyleSwiper.realIndex, activeIndex: serviceStyleSwiper.activeIndex });
						// #endregion
						setTimeout(updateGalleryFromStyleSlide, 100);
					});

					// Update gallery when a slide is clicked
					serviceStyleSwiper.on('click', function() {
						// #region agent log
						console.log('[DEBUG H2] click event fired:', { realIndex: serviceStyleSwiper.realIndex, activeIndex: serviceStyleSwiper.activeIndex });
						// #endregion
						setTimeout(updateGalleryFromStyleSlide, 100);
					});

					// Initialize gallery on page load
					// #region agent log
					console.log('[DEBUG H1] Init: calling updateGalleryFromStyleSlide');
					// #endregion
					updateGalleryFromStyleSlide();
				}

					// Gallery Slider
				const ServiceGallerySwiper = document.querySelector('.myServiceGallerySwiper');
				if (ServiceGallerySwiper) {
					new window.Swiper('.myServiceGallerySwiper', {
						direction: 'horizontal',
						loop: true,
						centeredSlides: true,
						slidesPerView: 'auto',
						spaceBetween: 10,
						speed: 2500,
						autoplay: {
							delay: 0,
							disableOnInteraction: true,
						},
						breakpoints: {
							'@0.00': {
								slidesPerView: 2.5,
								spaceBetween: 1,
							},
							'@0.75': {
								slidesPerView: 3.5,
								spaceBetween: 1,
							},
							'@1.00': {
								slidesPerView: 4,
								spaceBetween: 1,
							},
							'@1.50': {
								slidesPerView: 5,
								spaceBetween: 1,
							},
						},
						coverflowEffect: {
							rotate: 0,
							stretch: 0,
							depth: 0,
							modifier: 1,
							slideShadows: true,
						},
						additionalSlides: 1,
					});
				}

				// Gallery Column Swipers - Each column scrolls independently
				const galleryColumns = document.querySelectorAll('.saGalleryColumnSwiper');
				galleryColumns.forEach((column, index) => {
					const scrollDirection = column.dataset.direction || 'up';
					const baseSpeed = 12000;
					// Vary speed slightly per column for organic feel
					const speed = baseSpeed + (index * 2000);

					new window.Swiper(column, {
						direction: 'vertical',
						loop: true,
						slidesPerView: 'auto',
						spaceBetween: 16,
						speed: speed,
						pauseOnMouseEnter: true,
						autoplay: {
							delay: 0,
							disableOnInteraction: false,
							reverseDirection: scrollDirection === 'down',
						},
					});
				});

					// Barber Slider - Initialize only the first visible one
				// Other barber swipers are initialized dynamically when style changes
				const visibleBarberSection = document.querySelector('.style-barbers:not([style*="display: none"])');
				if (visibleBarberSection) {
					const firstBarberSwiper = visibleBarberSection.querySelector('.myServiceBarberSwiper');
					if (firstBarberSwiper) {
						new window.Swiper(firstBarberSwiper, {
							loop: true,
							centeredSlides: true,
							slidesPerView: 'auto',
							spaceBetween: 10,
							freeMode: true,
							breakpoints: {
								'@0.00': {
									slidesPerView: 2.5,
									spaceBetween: 10,
								},
								'@0.75': {
									slidesPerView: 3.5,
									spaceBetween: 10,
								},
								'@1.00': {
									slidesPerView: 4,
									spaceBetween: 10,
								},
								'@1.50': {
									slidesPerView: 5,
									spaceBetween: 10,
								},
							},
						});
					}
				}

				// Fallback: If no style-barbers wrapper exists, initialize legacy single swiper
				const legacyBarberSwiper = document.querySelector('#services-barber > .container-fluid .myServiceBarberSwiper');
				if (legacyBarberSwiper && !legacyBarberSwiper.swiper) {
					new window.Swiper(legacyBarberSwiper, {
						slidesPerView: 5,
						spaceBetween: 10,
						freeMode: true,
						breakpoints: {
							'@0.00': { slidesPerView: 2.5, spaceBetween: 10 },
							'@0.75': { slidesPerView: 3.5, spaceBetween: 10 },
							'@1.00': { slidesPerView: 4, spaceBetween: 10 },
							'@1.50': { slidesPerView: 5, spaceBetween: 10 },
						},
					});
				}

				// ========================================
				// CREW/EMPLOYEES CAROUSEL SECTION
				// ========================================

				// Initialize all crew barber gallery swipers
				const crewBarberSwiperEls = document.querySelectorAll('.crew-barber-swiper');
				if (crewBarberSwiperEls.length > 0) {
					crewBarberSwiperEls.forEach(function(el) {
						new window.Swiper(el, {
							loop: true,
							speed: 1000,
							effect: 'coverflow',
							grabCursor: true,
							centeredSlides: true,
							slideToClickedSlide: true,
							spaceBetween: 10,
							slidesPerView: 1.5,
							breakpoints: {
								576: {
									slidesPerView: 2.2,
									spaceBetween: 14,
								},
								768: {
									slidesPerView: 3.2,
									spaceBetween: 16,
								},
								992: {
									slidesPerView: 4,
									spaceBetween: 18,
								},
							},
							coverflowEffect: {
								rotate: 15,
								stretch: 0,
								depth: 0,
								modifier: 1,
								slideShadows: false,
							},
						});
					});
				}

				// Crew Navigation and Content Swipers (synced)
				const crewNavSwiperEl = document.querySelector('.myCrewSwiper');
				const crewContentSwiperEl = document.querySelector('.myCrewSwiper2');

				if (crewNavSwiperEl && crewContentSwiperEl) {
					// Vertical navigation swiper (left side names)
					const crewNavSwiper = new window.Swiper('.myCrewSwiper', {
						direction: 'vertical',
						loop: true,
						speed: 1000,
						spaceBetween: 20,
						slidesPerView: 5,
						centeredSlides: true,
						slideToClickedSlide: true,
						watchSlidesProgress: true,
						breakpoints: {
							0: {
								slidesPerView: 3,
							},
							768: {
								slidesPerView: 4,
							},
							992: {
								slidesPerView: 5,
							},
						},
					});

					// Content swiper (right side info) - synced with vertical nav
					const crewContentSwiper = new window.Swiper('.myCrewSwiper2', {
						loop: true,
						spaceBetween: 20,
						speed: 1000,
						autoplay: {
							delay: 4500,
							disableOnInteraction: false,
						},
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
						},
						thumbs: {
							swiper: crewNavSwiper,
						},
					});

					// Sync: when content swiper changes, update vertical nav to center the active slide
					crewContentSwiper.on('slideChange', function() {
						crewNavSwiper.slideToLoop(crewContentSwiper.realIndex);
					});

					// Sync: when vertical nav is clicked, update content swiper
					crewNavSwiper.on('click', function() {
						var clickedSlide = crewNavSwiper.clickedSlide;
						if (clickedSlide) {
							var realIndex = parseInt(clickedSlide.getAttribute('data-swiper-slide-index'));
							crewContentSwiper.slideToLoop(realIndex);
						}
					});

					// ========================================
					// BARBER GALLERY SWITCHING LOGIC
					// ========================================

					// Function to switch gallery based on barber ID
					function switchBarberGallery(barberId, barberName) {
						// Hide all galleries
						document.querySelectorAll('.barber-gallery').forEach(function(gallery) {
							gallery.style.display = 'none';
						});

						// Show the selected barber's gallery
						var targetGallery = document.querySelector('.barber-gallery[data-barber-id="' + barberId + '"]');
						if (targetGallery) {
							targetGallery.style.display = 'block';
						}

						// Update the title
						var titleSpan = document.getElementById('gallery-barber-name');
						if (titleSpan && barberName) {
							titleSpan.textContent = barberName;
						}
					}

					// Function to get barber info from current slide
					function updateGalleryFromCrewSlide() {
						var activeSlide = crewNavSwiper.slides[crewNavSwiper.activeIndex];
						if (activeSlide) {
							var barberId = activeSlide.getAttribute('data-barber-id');
							var barberName = activeSlide.getAttribute('data-barber-name');
							if (barberId) {
								switchBarberGallery(barberId, barberName);
							}
						}
					}

					// Update gallery when content swiper changes
					crewContentSwiper.on('slideChange', function() {
						// Small delay to ensure slide is fully transitioned
						setTimeout(updateGalleryFromCrewSlide, 100);
					});

					// Update gallery when vertical nav is clicked
					crewNavSwiper.on('click', function() {
						setTimeout(updateGalleryFromCrewSlide, 100);
					});

					// Initialize gallery on page load
					updateGalleryFromCrewSlide();
				}
}

/**
 * Utility function to create a basic slider programmatically
 * @param {string} selector - CSS selector for the slider container
 * @param {object} options - Swiper options
 */
function createSwiper(selector, options = {}) {
	const element = document.querySelector(selector);
	if (!element || typeof window.Swiper === 'undefined') {
		return null;
	}

	const defaultOptions = {
		loop: true,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
	};

	const mergedOptions = Object.assign({}, defaultOptions, options);
	return new window.Swiper(selector, mergedOptions);
}

// Make functions available globally
window.createCustomSwiper = createSwiper;
window.initializeFancybox = initializeFancybox;

// Mobile Menu
document.addEventListener('DOMContentLoaded', function () {
	const menuToggle = document.querySelector('.navbar-toggler');
	const mainNav = document.querySelector('.main-navigation-wrapper');
	const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

	// Mobile menu toggle
	if (menuToggle && mainNav) {
		menuToggle.addEventListener('click', function () {
			this.classList.toggle('active');
			mainNav.classList.toggle('mobile-active');
			document.body.classList.toggle('menu-open');
		});
	}

	// Dropdown toggles
	if (dropdownToggles) {
		dropdownToggles.forEach((toggle) => {
			toggle.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				// Toggle active state
				this.classList.toggle('active');

				// Find and toggle dropdown
				const dropdown = this.parentNode.querySelector('.menu-dropdown');
				if (dropdown) {
					dropdown.classList.toggle('show');
				}
			});
		});
	}

	// Close menu when clicking outside
	document.addEventListener('click', function (e) {
		if (window.innerWidth <= 1270) {
			if (!mainNav.contains(e.target) && !menuToggle.contains(e.target)) {
				mainNav.classList.remove('mobile-active');
				menuToggle.classList.remove('active');
				document.body.classList.remove('menu-open');
			}
		}
	});

	// Handle window resize
	let resizeTimer;
	window.addEventListener('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			if (window.innerWidth > 1270) {
				mainNav.classList.remove('mobile-active');
				menuToggle.classList.remove('active');
				document.body.classList.remove('menu-open');
				document.querySelectorAll('.menu-dropdown.show').forEach((dropdown) => {
					dropdown.classList.remove('show');
				});
			}
		}, 250);
	});
});



jQuery(document).ready(function($) {
	const $stickyNav = $('.sticky-nav-component');
	const $navContainer = $stickyNav.find('ul').first();
	const $navLinks = $navContainer.find('li a');

	if (!$stickyNav.length || !$navContainer.length || !$navLinks.length) {
		return;
	}

	function getHeaderOffset() {
		return $stickyNav.outerHeight() || 0;
	}

	let targetScrollLeft = 0;
	let animating = false;

	function smoothScrollLoop() {
		if (!animating) return;
		const current = $navContainer.scrollLeft();
		const diff = targetScrollLeft - current;

		$navContainer.scrollLeft(current + diff * 0.15);

		if (Math.abs(diff) > 0.5) {
			requestAnimationFrame(smoothScrollLoop);
		} else {
			animating = false;
		}
	}

	function setTargetScroll($link) {
		const containerWidth = $navContainer.width();
		const linkOffset = $link.position().left + $navContainer.scrollLeft();
		const linkWidth = $link.outerWidth();
		targetScrollLeft = linkOffset - containerWidth / 2 + linkWidth / 2;

		if (!animating) {
			animating = true;
			requestAnimationFrame(smoothScrollLoop);
		}
	}

	let lastActiveId = '';

	$navLinks.on('click', function (e) {
		e.preventDefault();
		const target = $(this).attr('href');
		const $targetEl = $(target);

		if ($targetEl.length) {
			const headerOffset = getHeaderOffset() + 240;

			$('html, body').animate(
				{
					scrollTop: $targetEl.offset().top - headerOffset,
				},
				600
			);

			if (window.innerWidth < 1200) {
				lastActiveId = target;
				setTargetScroll($(this));
			}
		}
	});

	const sections = [];
	$navLinks.each(function () {
		const id = $(this).attr('href');
		if (id && id.startsWith('#') && $(id).length) {
			sections.push($(id));
		}
	});

	let scrollSpyTicking = false;

	function runScrollSpy() {
		scrollSpyTicking = false;
		const headerOffset = getHeaderOffset() + 10;
		const scrollTop = $(window).scrollTop();
		const windowHeight = $(window).height();
		const scrollPos = scrollTop + windowHeight / 3;
		const docBottom = scrollTop + windowHeight;
		const docHeight = $(document).height();

		let currentId = '';
		sections.forEach(function ($section, index) {
			const top = $section.offset().top - headerOffset;
			const bottom = top + $section.outerHeight();

			if (scrollPos >= top && scrollPos < bottom) {
				currentId = '#' + $section.attr('id');
			}

			if (index === sections.length - 1 && docBottom >= docHeight - 2) {
				currentId = '#' + $section.attr('id');
			}
		});

		if (currentId) {
			$navLinks.removeClass('active');
			const $activeLink = $navLinks.filter('[href="' + currentId + '"]').addClass('active');

			if (window.innerWidth < 1200 && currentId !== lastActiveId) {
				lastActiveId = currentId;
				setTargetScroll($activeLink);
			}
		}
	}

	$(window).on('scroll', function () {
		if (!scrollSpyTicking) {
			scrollSpyTicking = true;
			requestAnimationFrame(runScrollSpy);
		}
	});

	requestAnimationFrame(runScrollSpy);
});
